export default __webpack_public_path__ + "static/media/bq-sa.6a4acbf8.svg";